import React from 'react'
import moment from 'moment'
import { TABLA_CAMIONES_EN_CIRCUITO, TABLA_CDMD_EXPORTADOR_CEREAL, TABLA_CDMD_CEREAL_PESO_TOTAL } from '../../../../../config/tables'
import { COLUMNS_CDMD_EXPORTADOR_CEREAL, COLUMNS_CDMD_CEREAL_PESO_TOTAL, getColumnasCamionesEnCircuito } from './constantesCamionesEnCircuito'
import CuadroDeMando from '../../../../../models/dashboard/cuadro_de_mando'
import CuadroDeMandoExpCereal from '../../../../../models/dashboard/cuadro_de_mando_exp_cereal'
import _ from 'lodash'
import CamionesEnCircuitoPorFechaCupo from '../components/CamionesEnCircuitoPorFechaCupo'
import CartaDePorteVetada from '../../../../../models/cartaDePorte/carta_de_porte_vetada'

export function groupedData (data, vetadas = null) {
  const groupedByCereal = _.groupBy(data, (item) => `${item.cereal}-${item.cerealVariedad}`)
  const groupedByCerealAndVariety = _.mapValues(groupedByCereal, (cerealGroup) => {
    return _.reduce(cerealGroup, (acc, item) => {
      const { cereal, nombreCereal, cerealVariedad, ...rest } = item
      const key = `${cereal.trim()}-${cerealVariedad.trim()}`

      let vetadasPorCereal = []

      if (vetadas && cerealVariedad.trim() === 'UNDEF') {
        vetadasPorCereal = vetadas.filter((v) => v.cereal && (v.cereal.trim() === cereal.trim()))
      }

      const cantidadVetadas = (vetadasPorCereal.length > 0) ? vetadasPorCereal[0].cantidad : 0

      return {
        ...acc,
        ..._.mapValues(rest, (value, prop) => (acc[key] && acc[key][prop] ? acc[key][prop] : 0) + value),
        cereal,
        nombreCereal,
        cerealVariedad,
        cantidadVetadas: cantidadVetadas,
        [key]: {
          ..._.mapValues(rest, (value, prop) => (acc[key] && acc[key][prop] ? acc[key][prop] : 0) + value)
        }
      }
    }, {})
  })

  return groupedByCerealAndVariety
}

export function parseDataGroup (data, vetadas) {
  const parsedData = []

  if (data.filas_procesadas > 0) {
    const agrupado = groupedData(data.filas, vetadas)
    const result = _.values(agrupado).flat()
    result.map((entry) => {
      return parsedData.push({ ...entry, entry: entry })
    })
  }
  return parsedData
}

export function parseDataConTotalPorFecha (data, vetadas, option) {
  const parsedData = []

  if (data.filas_procesadas > 0) {
    let resultData

    const hoy = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')

    if (option === 0) {
      resultData = data.filas
    } else if (option === 1) {
      resultData = data.filas.filter((d) => (moment(d.fechaCupo).format('DD-MM-YYYY') === (moment(new Date()).format('DD-MM-YYYY'))))
    } else if (option === 2) {
      resultData = data.filas.filter((d) => (moment(d.fechaCupo).format('DD-MM-YYYY') !== (moment(new Date()).format('DD-MM-YYYY'))) &&
                                             moment(d.fechaCupo, 'YYYY-MM-DD HH:mm:ss').isBefore(hoy))
    } else if (option === 3) {
      resultData = data.filas.filter((d) => (moment(d.fechaCupo).format('DD-MM-YYYY') !== (moment(new Date()).format('DD-MM-YYYY'))) &&
                                              moment(d.fechaCupo, 'YYYY-MM-DD HH:mm:ss').isAfter(hoy))
    }

    const agrupado = groupedData(resultData, vetadas)
    const result = _.values(agrupado).flat()

    result.map((entry) => {
      return parsedData.push({ ...entry, entry: entry })
    })
  }
  return parsedData
}

export function parseData (data) {
  const parsedData = []

  if (data.filas_procesadas > 0) {
    data.filas.map((entry) => {
      const conDescarga = {
        cantidad: entry.descargados,
        totalPeso: entry.descargadosPeso
      }

      const sinDescargar = {
        cantidad: entry.totalSinDescargar,
        totalPeso: entry.totalSinDescargarPeso
      }

      const cantidadTotal = {
        cantidad: entry.total,
        totalPeso: entry.totalPeso
      }
      return parsedData.push({ ...entry, conDescarga: conDescarga, sinDescargar: sinDescargar, cantidadTotal: cantidadTotal })
    })
  }
  return parsedData
}

export function actualizarDatosPorFechaCupo (option, autodescargables = false) {
  return (dispatch, getState) => {
    const state = getState()
    const d = state.dashboard.cdmdCircuito
    const vetadas = state.dashboard.cartasVetadasTotal
    const data = parseDataConTotalPorFecha(d, vetadas, parseInt(option))

    const showVetadas = option === 0 && !autodescargables
    const columnas = getColumnasCamionesEnCircuito(autodescargables, showVetadas)

    const customToolbar = () => { return <CamionesEnCircuitoPorFechaCupo /> }
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: columnas,
        data: data,
        title: 'Camiones en circuito de descarga',
        isLoading: false,
        fixed2Decimales: false,
        responsive: 'vertical',
        extraOptions: { customToolbar, print: false, pagination: false, download: false, filter: false, search: false, viewColumns: false }
      },
      id: TABLA_CAMIONES_EN_CIRCUITO
    })
  }
}

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_EN_CIRCUITO
    })
    Promise.all([
      CuadroDeMando.getCantidadTotalPorCereal(),
      CartaDePorteVetada.getTotalVetadasPorCereal()
    ]).then(([cdmd, vetadas]) => {
      dispatch({ type: 'CUADRO_DE_MANDO_CIRCUITO', cdmd })
      dispatch({ type: 'CARTAS_DE_PORTE_VETADAS_TOTAL', vetadas })
      const data = parseDataGroup(cdmd, vetadas)
      const customToolbar = () => { return <CamionesEnCircuitoPorFechaCupo /> }
      const showVetadas = true
      const autodescargables = false
      const columnas = getColumnasCamionesEnCircuito(autodescargables, showVetadas)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: 'Camiones en circuito de descarga',
          isLoading: false,
          fixed2Decimales: false,
          responsive: 'vertical',
          extraOptions: { customToolbar, print: false, pagination: false, download: false, filter: false, search: false, viewColumns: false }
        },
        id: TABLA_CAMIONES_EN_CIRCUITO
      })
    })
  }
}

export function parseDataExpCereal (data) {
  const parsedData = []

  if (data.filas_procesadas > 0) {
    data.filas.map((entry) => {
      return parsedData.push({ ...entry })
    })
  }
  return parsedData
}

export function actualizarTablaCDMDExpCereal () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CDMD_EXPORTADOR_CEREAL
    })
    CuadroDeMandoExpCereal.getCdmdExpCereal().then((d) => {
      const data = parseDataExpCereal(d)
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_CDMD_EXPORTADOR_CEREAL,
          data: data,
          title: 'Camiones en circuito por exportador y cereal',
          isLoading: false,
          fixed2Decimales: false,
          responsive: 'vertical',
          extraOptions: {
            customToolbar,
            print: false,
            pagination: false,
            search: false,
            viewColumns: false,
            download: false,
            tableBodyMaxHeight: '599px'
          }
        },
        id: TABLA_CDMD_EXPORTADOR_CEREAL
      })
    })
  }
}

export function parseDataCerealTotal (data) {
  const parsedData = []

  if (data.filas_procesadas > 0) {
    data.filas.map((entry) => {
      return parsedData.push({ ...entry })
    })
  }
  return parsedData
}

export function actualizarTablaCerealPesoTotal () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CDMD_CEREAL_PESO_TOTAL
    })
    CuadroDeMandoExpCereal.getCdmdCereal()
      .then((d) => {
        const data = parseDataCerealTotal(d)
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_CDMD_CEREAL_PESO_TOTAL,
            data: data,
            title: 'Camiones en circuito por cereal',
            isLoading: false,
            fixed2Decimales: false,
            responsive: 'vertical',
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              download: false,
              tableBodyMaxHeight: '599px',
              search: false,
              filter: false,
              viewColumns: false
            }
          },
          id: TABLA_CDMD_CEREAL_PESO_TOTAL
        })
      })
  }
}
